import React from 'react';
import { PasswordModalController, PasswordModalControllerProps } from './PasswordModal.controller';
import { gql } from '@apollo/client';
import { useChangePasswordMutation, useSetPasswordMutation } from '../../../models/graphql';

export type PasswordModalApolloProps = Omit<
  PasswordModalControllerProps,
  'changePasswordMutation' | 'setPasswordMutation' | 'password'
> & {
  // ...
};

gql`
  mutation ChangePassword($oldPassword: String!, $newPassword: String!, $userId: ID) {
    updateUser(input: { oldPassword: $oldPassword, newPassword: $newPassword }, userId: $userId) {
      ...UserFields
    }
  }
  mutation SetPassword($newPassword: String!, $userId: ID) {
    updateUser(input: { newPassword: $newPassword }, userId: $userId) {
      ...UserFields
    }
  }
`;

export const PasswordModalApollo = (props: PasswordModalApolloProps): JSX.Element => {
  const [changePasswordMutation] = useChangePasswordMutation({
    onCompleted: () => {
      props.onClose();
    }
  });
  const [setPasswordMutation] = useSetPasswordMutation({
    onCompleted: () => {
      props.onClose();
    }
  });

  const controllerProps: PasswordModalControllerProps = {
    ...props,
    changePasswordMutation,
    setPasswordMutation
  };
  return <PasswordModalController {...controllerProps} />;
};
